<template>
    <div class="row">
        <div class="col-12">
            <h4>Your update tasks</h4>
            <el-table
              :data="getUserTasks"
              style="width: 100%"
              :row-class-name="tableRowClassName">
              <el-table-column type="expand">
                <template slot-scope="props">
                    <Task :task="props.row.childTasks"></Task>
                </template>
              </el-table-column>
              <el-table-column
                label="ID"
                prop="id">
              </el-table-column>
              <el-table-column
                label="Status"
                prop="lastStatus">
              </el-table-column>
              <el-table-column
                label="Action">
                <template slot-scope="scope">
                    <el-button
                    size="mini"
                    v-if="scope.row.lastStatus == 'CREATED' || scope.row.lastStatus == 'BUSY' || scope.row.lastStatus == 'TO_RUN'"
                    @click="runTask(scope.row)">Run</el-button>
                    <el-button
                    size="mini"
                    type="warning"
                    v-if="scope.row.lastStatus !== 'STOP' && scope.row.lastStatus !== 'DONE' && scope.row.lastStatus !== 'STARTED'"
                    @click="pauseTask(scope.row)">Pause</el-button>

                    <el-button
                    size="mini"
                    type="danger"
                    v-if="scope.row.lastStatus === 'DONE'"
                    @click="removeTask(scope.row)">Remove</el-button>

                    <el-button
                    size="mini"
                    type="warning"
                    v-if="scope.row.lastStatus == 'STOP'"
                    @click="unpauseTask(scope.row)">Unpause</el-button>

                </template>
              </el-table-column>
            </el-table>
        </div>
    </div>
</template>


<script>
  import _ from 'underscore';

  import { mapActions, mapGetters, mapMutations } from 'vuex'
  import Task from './Task'

  export default {
    components: {
      Task
    },
    data(){
        return { 
            intervalRefreshData: null
        }
    },
    methods: {
      ...mapActions([
        'getUserTasksAsync',
        'runTaskAsync',
        'unpauseTaskAsync',
        'pauseTaskAsync',
        'removeTaskAsync'
      ]),
      ...mapMutations(['addAlert']),
      runTask(item){
          this.runTaskAsync(item.id)
      },
      pauseTask(item){
          this.pauseTaskAsync(item.id)
      },
      unpauseTask(item){
          this.unpauseTaskAsync(item.id)
      },
      removeTask(item){
          this.removeTaskAsync(item.id)
          this.getUserTasksAsync()
      },
      tableRowClassName({row, rowIndex}) {
        return row.lastStatus;
      }
    },
    async created(){
        this.getUserTasksAsync()
        this.intervalRefreshData = setInterval( this.getUserTasksAsync, 30000)
    },
    beforeDestroy(){
        clearInterval(this.intervalRefreshData)
    },
    computed: {
        ...mapGetters({
            getUserTasks: 'getUserTasks',
        }),
    }
  };
</script> 

<style lang="scss">

  .el-table .CREATED{
    //background: oldlace;
  }
  .el-table .STARTED{
    background: rgb(115, 163, 250);
    &:hover {
    background: rgb(115, 163, 250);
        td { 
                background: rgb(115, 163, 250) !important;
        }
    }
  }
  .el-table .DONE{
    background: rgb(70, 255, 79);
    &:hover {
        background: rgb(70, 255, 79);
        td { 
            background: rgb(70, 255, 79) !important;
        }
    }
  }
  .el-table .ERROR{
    background: rgb(255, 62, 62);
    &:hover {
        background-color: rgb(255, 62, 62);

        td { 
            background-color: rgb(255, 62, 62) !important;
        }
    }
  }
</style>